import { ReportsPage } from '@/features/reports/components';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/reports/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['reports.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return <ReportsPage />;
}
